import { AnalyticsEventNames } from '../enum/calendar/analytics-event-names.enums';
import { AnalyticsEventTypes } from '../enum/calendar/analytics-event-types.enum';

export const mapEventType = (eventType: AnalyticsEventTypes): string => {
  switch (eventType) {
    case AnalyticsEventTypes.FOCUS:
      return AnalyticsEventNames.FOCUS;
    case AnalyticsEventTypes.INTERNAL:
      return AnalyticsEventNames.INTERNAL;
    case AnalyticsEventTypes.EXTERNAL:
      return AnalyticsEventNames.EXTERNAL;
    default:
      return eventType;
  }
};
